import React, {Component} from 'react';
import * as apis from '../../utils/apis';
import { connect } from "react-redux";
import DataGrid, {
    Column,
    Editing,
    Popup,
    Position,
    Lookup,
    GroupPanel,
    FilterPanel,
    FilterRow,
    ColumnChooser,
    Scrolling,
    RequiredRule,
    FormItem
} from 'devextreme-react/ui/data-grid';



const getHeight = () => {
    return (window.innerHeight - 48)
}

class PRStatusMapGrid extends Component {
    state = {
        
    };

    resize = () => {
     
        this.gridview.instance.option('height',getHeight());
      }
    
      componentDidMount() {
        window.addEventListener('resize', this.resize)
      }
      
      componentWillUnmount() {
        window.removeEventListener('resize', this.resize);
      }

      setDefaultNewValues = (e) => {
        e.data.active = true; 
      }

      onToolbarPreparing = (e) => {
        e.toolbarOptions.items.unshift({
            location: 'after',
            widget: 'dxButton',
            options: {
              icon: 'refresh',
              onClick: this.refreshGrid 
            }
          });
    }

    refreshGrid = () => {
        this.gridview.instance.refresh(true);
    }

    render() {
        return  (
            <DataGrid 
             dataSource={apis.PartRequestStatusMapDataSource(this.props.user.access_token)}  
            noDataText="There are no matching status maps in the system."
            rowAlternationEnabled={true}  
            showBorders={true}
            showRowLines={true}
            showColumnLines={true}  
            columnHidingEnabled={false}
            allowColumnReordering={true}
            allowColumnResizing={true}
            stateStoring={{ enabled: 'true',type: 'localStorage', storageKey: 'woStatusMapGrid' }}
            height={getHeight}
            width="100%" ref={(gv) => {this.gridview = gv}}
            onInitNewRow={this.setDefaultNewValues} onToolbarPreparing={this.onToolbarPreparing} 
         >
         
         <Editing
            mode={'popup'}
            allowUpdating={this.props.grants.rights.adminPRStatusMap}
            allowDeleting={this.props.grants.rights.adminPRStatusMap}
            allowAdding={this.props.grants.rights.adminPRStatusMap} >
             <Popup title={'Part Request Status Map'} showTitle={true} width={700} height={345}>
              <Position my={'center'} at={'center'} of={window} />
            </Popup>
        </Editing>
        <Scrolling mode="virtual" />
        <GroupPanel visible={true} />
        <FilterRow visible={true} />
        <FilterPanel visible ={true} />
  
        <ColumnChooser enabled={true} />

        <Column dataField={'id'} visible={false}>
            <FormItem visible={false} />
        </Column>
        <Column dataField={'userGroupId'} caption="User Group">
             <Lookup dataSource={apis.UserGroupWithAccessDataSource(this.props.user.access_token)} displayExpr={'name'} valueExpr={'id'} /> 
             <RequiredRule />
        </Column>
        <Column dataField={'partRequestStatusId'} caption="Status">
             <Lookup dataSource={apis.PartRequestStatusesDataSource(this.props.user.access_token)} displayExpr={'text'} valueExpr={'id'} /> 
             <RequiredRule />
        </Column>
 
       
        </DataGrid>
        );
    }


}

const mapStateToProps = (state) => {
  return {
      user: state.oidc.user,
      grants: state.rights
  };
}


export default connect(mapStateToProps,null)(PRStatusMapGrid)